import Breadcrumbs from '@v2/shared/components/Breadcrumbs';
import ContentCard from '@v2/shared/components/ContentCard';
import DocumentHtml from '@v2/shared/components/DocumentHtml';
import PageHeading from '@v2/shared/components/PageHeading';

export type Props = {
  /** The terms themselves, from the site's own `includes/modules/legal/tos/`. See below. */
  html: string;
};

/**
 * /tos, on every brand.
 *
 * Shared rather than per-brand because there is nothing brand-specific left once the
 * document is passed in: `tosVersion` — a per-site option an administrator sets in
 * adminmagz — picks one of a set of dated documents at request time, and each brand's
 * `includes/modules/general/tos_contents.html` already resolves to its own directory. So
 * the page is a frame around a document the template chose, and the frame is the same
 * frame four times.
 *
 * The document stays a document, and arrives here as one, because the version that resolves
 * is recorded against every order as the terms that customer accepted — and this page is
 * where the customer reads them, since the checkout agreement links here.
 *
 * A brand that wants to differ adds `brands/<brand>/Pages/TermsOfUse` and it wins:
 * `resolve.ts` tries the brand before shared. That is how DiscountMags' privacy page
 * keeps its own heading beside the shared one next door.
 */
export default function TermsOfUse({ html }: Props) {
  return (
    <>
      <Breadcrumbs items={[{ label: 'Home', href: '/' }, { label: 'Terms of Use' }]} />

      <PageHeading eyebrow="Customer Information">Terms of Use</PageHeading>

      <ContentCard className="prose mt-6">
        <DocumentHtml html={html} />
      </ContentCard>
    </>
  );
}

TermsOfUse.layoutName = 'Layouts.Institutional';
